import script from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBot.vue?vue&type=script&setup=true&lang=js"

import "./ChatBot.vue?vue&type=style&index=0&id=d225795c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d225795c"]])

export default __exports__